import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


function DocumentationDataMergePageContent() {

	return (
		<Box sx={{ width: '100%', maxWidth: 1024 }}>
			<Typography variant="h5" gutterBottom>
				HowTo
			</Typography>
			<Typography variant="body1" gutterBottom>
				<ol>
					<li><b>[Excel]</b> Create an excel with all the information that you want to have on the design (e.g. name, email, description).</li>
					<li><b>[Excel]</b> Add an extra column in the excel, named as '@Image. Please note that the "'@" (apostrophie @) is very important! Then add on each row the path of the image to the relative directory to the csv file. You can have it in the same or different directory if you wish. [Tip] In the directory browser, select all images and copy paste to the excel to generate the file names.</li>
					<li><b>[Excel]</b> Save the excel as .csv file.</li>
					<li><b>[InDesign]</b> Window → utilities → data merge.</li>
					<li><b>[InDesign]</b> Click on the humburger button (top right) → select data source → select open on the csv file.</li>
					<li><b>[InDesign]</b> With the select or text tool, highlight the actual text in the design and then click on the row on the merge tool (highlight the "name" in the design and click name on the merge tool).</li>
					<li><b>[InDesign]</b> When you are done with all the fields, you can click the preview to see the information coming through the design.</li>
					<li><b>[InDesign]</b> You can click on the humburger button and "update data source" if you have amended the excel to auto-refresh the data.</li>
					<li><b>[InDesign]</b> Click on the humburger button and "export as pdf" to download all auto-generated items (many configuration options to explore here...)</li>
				</ol>
				Bug with same last names although different artist names (solution do not include col last name where entry is identical even if this col is not mapped) (edited)
			</Typography>

			<Typography variant="h5" gutterBottom>
				Data Merge errors
			</Typography>
			<Typography variant="body1" gutterBottom>
				Symbol bugs:
				<ol>
					<li>Euro sign <b>Ç¨</b> instead of <b>€</b></li>
					<li><b>√º</b> instead of <b>ü</b></li>
					<li><b>‚ÄúC‚Äù</b> instead of <b>“C”</b> (quotation marks)</li>
					<li><b>¬£</b> instead of <b>£</b></li>
					<li><b>‚Äô</b> instead of <b>’</b></li>
					<li><b>√©</b> instead of <b>é</b></li>
					<li>Angelė Šimoliūnienė ...</li>
				</ol>
				Bug with same last names although different artist names (solution do not include col last name where entry is identical even if this col is not mapped) (edited)
			</Typography>
		</Box>
	);
}

export default DocumentationDataMergePageContent;